import './AssignmentList.scss'
import _ from 'lodash'
import React, {Component} from 'react'
import { connect } from 'react-redux'
import AssignmentTable from './AssignmentTable'

import {
  fetchAssignments, searchAssignments
} from 'broker/redux/assignment'

import {
  fetchMarkets, fetchAgents, fetchSourceTypes
} from 'broker/redux/account'

import { selectIsTransitionBroker } from 'broker/selectors/auth'

import { getTimeframeFromFilterList, getQueriesFromFilterList, filtersWithValues, exportSearchFiltersForSegment } from 'broker/util/helper'

import { BUYER_TYPE, PRICE, REFERRAL_EXPORT_TIMEFRAME, LEAD_TYPE_OPTIONS } from 'common/constants'

import { segmentEventTracker } from 'common/analytics'
import {GenericLeadsDownloader} from "broker/util/downloader";
import DownloadModal from "broker/views/components/common/DownloadModal";
import { FilteredList } from 'broker/views/components/common/Filter/FilteredList'

const FILTER_KEYS = ['stage', 'market', 'client', 'price', 'agent', 'source', 'timeframe', 'lead_type']
const FILTER_TYPE_OPTIONS = [
  {value: 'stage', label: 'Client Stage'},
  {value: 'market', label: 'Market'},
  {value: 'client', label: 'Client Category'},
  {value: 'price', label: 'Price Range'},
  {value: 'agent', label: 'Agent Name'},
  {value: 'source', label: 'Source Name'},
  {value: 'timeframe', label: 'Time Period'},
  {value: 'market_vip', label: 'Market VIP'},
  {value: 'lead_type', label: 'Lead Type'},
]
const MARKET_VIP_FILTER = [{value: 'true', label: 'Only'}]


class AssignmentList extends Component {

  constructor(props) {
    super(props)

    this.state = {
      excludeOnHold: false,
      spilloverOnly: false,
      filters: [{filter_type: 'timeframe', filter_value: 'month'}],
      activeFilters: [{filter_type: 'timeframe', filter_value: 'month'}],
      dirty: false,
      options: {
        stage: [{value:"new",label:"New"},{value:"spoke-to-client",label:"Spoke"},
                {value:"met-showing",label:"Met / House Hunted"},{value:"offers-made",label:"Made An Offer"},{value:"contract",label:"Under Contract"},
                {value:"closed",label:"Closed"}],
        agent: [{value: "waiting-for-agents", label:"Waiting for agents..."}],
        source: [{value: "waiting-for-sources", label:"Waiting for sources..."}],
        client: BUYER_TYPE,
        price: PRICE,
        timeframe: REFERRAL_EXPORT_TIMEFRAME,
        market_vip: MARKET_VIP_FILTER,
        lead_type: LEAD_TYPE_OPTIONS,
      },
      unusedFilters: FILTER_KEYS.filter(filter => filter.value !== 'timeframe'),
    }
    this.downloader = new GenericLeadsDownloader()
    this.handleAssignmentExport = this.handleAssignmentExport.bind(this)
    this.search = this.search.bind(this)
    this.handleFilter = this.handleFilter.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
  }

  componentDidMount() {
    const { dispatch, isTransitionBroker } = this.props

    if (isTransitionBroker && !_.includes(FILTER_KEYS, 'market_vip')) {
      FILTER_KEYS.push('market_vip')
    }

    return Promise.all([
      dispatch(fetchMarkets()).then(response => {
        const market = response.markets.map(market => {
          return {value: market.id, label: market.name}
        })
        this.setState(prevState => ({
          options: {
            ...prevState.options,
            market
          }
      }))}),
      dispatch(fetchSourceTypes()).then(response => {
          const source = (response.source_types || []).map(source_type => {
            return {value: source_type.id, label: source_type.name}
          })
          this.setState(prevState => ({
            options: {
              ...prevState.options,
              source
            }
      }))}),
      dispatch(fetchAgents()).then(response => {
        let agentOptions = response.agents.map(agent => {
          return {value: agent.id, label: agent.name}
        })
        if (this.props.account.is_partner_brokerage) {
          agentOptions.unshift({value:'network',label:'Network'})
        }

        const { options } = this.state
        this.setState(prevState => ({
          options: {
            ...prevState.options,
            agent: agentOptions
          },
          extraForSegment: {
            ...prevState.extraForSegment,
            agentUserHash: response.agents.map(agent => {
              return { id: agent.id, userHash: agent.user_hash }
            })}
        }))
      }),
      this.setInitialState(),
    ])
  }

  toggleExcludeOnHold = (e) => {
    this.setState({excludeOnHold: e.target.checked, dirty: true})
  }

  toggleNetworkReferrals = (e) => {
    this.setState({spilloverOnly: e.target.checked, dirty: true})
  }

  setInitialState = () => {
    const { location } = this.props
    const initialStateAgentId = _.get(location, ['state', 'agentId'])
    if (initialStateAgentId) {
      const filters = [{filter_type: 'timeframe', filter_value: 'all'}, {filter_type:'agent', filter_value:initialStateAgentId}]
      this.setState({
        filters,
        activeFilters: filters
      }, this.search)
    }
  }

  addFilter = () => {
    this.setState({
      filters: [...this.state.filters].concat({filter_type: null, filter_value: null})
    })
    this.updateFilterType(this.state.filters.length, this.state.unusedFilters[0])
  }

  removeFilter = (idx) => {
    let filters = [...this.state.filters]

    filters.splice(idx, 1)
    let newActiveFilters = filters.filter(filter => filter.filter_type && filter.filter_value)
    let unusedFilters = FILTER_KEYS.filter(val => filters.every(filter => filter.filter_type!==val))

    this.setState({
      filters,
      unusedFilters,
      activeFilters: newActiveFilters,
      dirty: true
    })
  }

  updateFilterType = (idx, filter_type) => {
    let filters = [...this.state.filters]
    filters[idx] = {
      filter_type,
      filter_value: null
    }
    let unusedFilters = FILTER_KEYS.filter(val => filters.every(filter => filter.filter_type!==val))
    this.setState({
      filters,
      unusedFilters
    })
  }

  updateFilterValue = (idx, filter_value, run_search = false) => {
    const search_callback = run_search ? this.handleFilter : null
    let filters = [...this.state.filters]
    filters[idx]['filter_value'] = filter_value
    let activeFilters = filters.filter(filter => filter.filter_type && filter.filter_value)
    this.setState({
      filters,
      activeFilters,
      dirty: true
    }, search_callback)
  }

  handleFilter = _.debounce(() => { this.search() } , 2000)

  handleSearch = _.debounce((searchTerm) => {
      this.setState({searchTerm})
      this.search(searchTerm)
    }, 800)

  search = (term) => {
    this.downloader.initializeSearchState()
    const activeFilters = getQueriesFromFilterList(this.state.activeFilters)

    if (term || !!this.state.searchTerm || activeFilters.length > 0) {
      term = term || this.state.searchTerm
      this.props.dispatch(searchAssignments(getTimeframeFromFilterList(
          this.state.activeFilters), term, activeFilters, this.state.excludeOnHold, this.state.spilloverOnly,
          this.props.nav)
        ).then(() => {
          this.setState({searching: false})
        }).catch((error) => {
          this.downloader.searchTimedOut()
          throw error
        })
    } else {
      this.props.dispatch(fetchAssignments(getTimeframeFromFilterList(
          this.state.activeFilters), this.state.excludeOnHold, this.state.spilloverOnly, this.props.nav)
        ).then(() => {
          this.setState({searching: false})
        }).catch((error) => {
          this.downloader.searchTimedOut()
          throw error
        })
    }
    const filteredFilters = filtersWithValues(this.state.filters)
    this.setState({searching: true, dirty: false, filters: filteredFilters})
  }

  handleAssignmentExport = () => {
    const baseSegmentProperties = {
      'downloaded_data': 'referrals'
    }

    const { activeFilters, extraForSegment } = this.state
    const agentFilter = activeFilters.find(filterEntry => filterEntry.filter_type === 'agent')
    const agentUserHashArray = extraForSegment ? extraForSegment.agentUserHash : []
    const foundAgent = agentFilter && agentUserHashArray.find(agent => agent.id === agentFilter.filter_value)
    const agentUserHash = agentFilter && foundAgent && foundAgent.userHash

    const searchFiltersForSegmentExport = exportSearchFiltersForSegment(
      FILTER_TYPE_OPTIONS,
      this.state.activeFilters,
      agentUserHash && { 'agent': agentUserHash }
    )

    segmentEventTracker('Data Downloaded',{
      ...baseSegmentProperties,
      ...searchFiltersForSegmentExport
    })

    this.downloader.download({
      exportUrl: '/download/assignments',
      auth: this.props.auth, email: this.props.email, dispatch: this.props.dispatch, account: this.props.account,
      activeFilters: this.state.activeFilters, searchTerm: this.state.searchTerm,
      spilloverOnly: this.state.spilloverOnly, excludeOnHold: this.state.excludeOnHold})
  }

  render() {
    const { props, state } = this
    const { root } = props
    const { isLoading } = root
    const activeFilters = state.activeFilters

    const defaultNav = {next_page: null, prev_page: null, page_number: 1}
    const useNav = {...defaultNav, ...(_.get(props, 'assignment.nav', {}))}
    const timeFrameFilter = this.state.filters[0]
    const timeFrameOptions = this.state.options[timeFrameFilter.filter_type]

    function getPage(forward) {
      const { activeFilters, excludeOnHold, spilloverOnly, searchTerm } = state
      let newNav = {
        'page_number': forward ? useNav.page_number + 1: useNav.page_number - 1,
        'page_key': forward ? useNav.next_page : useNav.prev_page
      }
      props.dispatch(searchAssignments(getTimeframeFromFilterList(activeFilters), searchTerm, activeFilters, excludeOnHold, spilloverOnly, newNav))
    }

    function forward() {
      getPage(true)
    }

    function backward() {
      getPage(false)
    }

    function renderSection(assignments) {
      return (
        <div key={"assignmentsList"}>
          { assignments ?
            <AssignmentTable
              activeFilters={activeFilters}
              filterTypeOptions={FILTER_TYPE_OPTIONS}
              showingReleased={false}
              assignmentList={assignments}
              showNote={true}
              fetch={fetchAssignments} {...props}
            /> : null }
        </div>)
    }
    const NoAssignmentSection = <div className="AssignmentList__none-found">
      <i className="fa fa-flag" aria-hidden="true"></i><div>No active referrals are assigned to your agents.</div>
    </div>


    let networkReferralsOptions

    if (props.account.is_partner_brokerage) {
      networkReferralsOptions = {
        disabled:false,
        onChange: this.toggleNetworkReferrals,
        toggled: this.state.spilloverOnly
      }
    }



    return (
      <div>
        <div className="AssignmentList">
          <FilteredList
            checkboxOptions={{onHold: { onChange: this.toggleExcludeOnHold}, networkReferrals: networkReferralsOptions}}
            dirty={this.state.dirty}
            filters={this.state.filters}
            filterOptions={this.state.options}
            isLoading={isLoading}
            maxLengthReached={Object.keys(this.state.options).length == (Object.keys(this.state.filters).length)}
            nav={this.props.assignment ? this.props.assignment.nav: null}
            timeFrameFilter={timeFrameFilter}
            timeFrameOptions={timeFrameOptions}
            typeOptionsConsts={FILTER_TYPE_OPTIONS}
            unusedFilters={this.state.unusedFilters}
            onAddFilter={this.addFilter}
            onApply={this.handleFilter}
            onExport={this.handleAssignmentExport}
            onPageForward={forward}
            onPageBackward={backward}
            onRemoveFilter={this.removeFilter}
            onSearch={this.handleSearch}
            onUpdateFilterType={this.updateFilterType}
            onUpdateFilterValue={this.updateFilterValue}
          >
            { props.assignment.search_results ? props.assignment.search_results.length !== 0 ? renderSection(props.assignment.search_results) : NoAssignmentSection : <div className="AssignmentList__loading pulse"/> }
          </FilteredList>
        </div>
        <DownloadModal {...this.props}/>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isTransitionBroker: selectIsTransitionBroker(state)
})

export default connect(mapStateToProps)(AssignmentList)
